import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CertificateService {

  constructor(private readonly httpClient: HttpClient) { }

  getCertificate(deviceSerialNumber: string):Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'certificate?batteryIdentifiers=' + deviceSerialNumber);
  }

  getCertificateStatus(deviceSerialNumber: string[]):Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'certificate-status?batteryIdentifiers=' + deviceSerialNumber);
  }

  requestCertificate(body: any): Observable<any> {
    return this.httpClient.post<any>(environment.apiEndpoint + 'generate-certificate', body);
  }
}
